import React from "react";

import { checkIsEmptyHtmlString } from "repoV2/utils/common/validators/validators";
import { classNames } from "repoV2/utils/common/render/classNames";
import commonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import { DisclaimerSection } from "../DisclaimerSection/DisclaimerSection";
import { useCheckoutBasicDetailsContext } from "../CheckoutBasicDetailsContextProvider";
import styles from "./DescriptionSection.module.scss";
import { useExpressInterestContext } from "../CheckoutExpressInterestContextProider";
import LimitedTimeOfferCard from "../LimitedTimeOfferCard/LimitedTimeOfferCard";
import SessionInfoCard from "../SessionInfoCard/SessionInfoCard";
import {
    useHasSessionDetailsFetched,
    useHideSessionDetailsFormGroup,
} from "../PaymentDetailsSection/modules/FormGroups/modules/SessionDetailsFormGroup/SessionDetailsFormGroup.utils";
import { useSyncTimezone } from "../PaymentDetailsSection/modules/FormGroups/modules/SessionDetailsFormGroup/modules/TimezoneSelector/TimezoneSelector.utils";

export const DescriptionSection = (props: { showPaymentModal: boolean }) => {
    const { showPaymentModal } = props;
    const { listingUuid, listingType, listingStatus, description } =
        useCheckoutBasicDetailsContext();
    const { listingExpired } = useExpressInterestContext();

    // We have two timezone fields, we need
    // to keep them in sync to each other. This
    // hook handles that
    useSyncTimezone();

    const { hideSessionDetailsFormGroup } = useHideSessionDetailsFormGroup({
        listingType,
        listingStatus,
    });

    const hasSessionDetailsFetched = useHasSessionDetailsFetched({
        listingUuid,
    });

    const areFormGroupsLoading =
        !hideSessionDetailsFormGroup && !hasSessionDetailsFetched;

    return (
        <section className={styles.container}>
            {listingExpired ? (
                <div className={styles.expressInterestMessage}>
                    There are no sessions available currently. Get in touch to
                    request a session.
                </div>
            ) : null}
            <LimitedTimeOfferCard
                classes={{
                    container: classNames(
                        commonStyles.hideInDesktop,
                        styles.limitedTimeOfferContainer
                    ),
                }}
            />
            {!hideSessionDetailsFormGroup &&
                !areFormGroupsLoading &&
                !showPaymentModal && (
                    <div
                        className={classNames(
                            commonStyles.hideInDesktop,
                            styles.sessions
                        )}
                    >
                        <SessionInfoCard />
                    </div>
                )}
            {checkIsEmptyHtmlString(description) ? null : (
                <div
                    className={styles.description}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: description,
                    }}
                />
            )}
            <DisclaimerSection />
        </section>
    );
};
